import React from 'react';
// import Zoom from 'react-reveal';
import { Modal, Button } from 'react-bootstrap';
import { deleteFunc } from '../../../customHooks';
import './DeleteModal.scss'

const DeleteModal = ({ closeDeleteModal, isdeletemodal,url,deleteId,setReload }) => {
  
  const deleteDatas = () => {
      deleteFunc(url,deleteId,setReload)
      closeDeleteModal()
      
  }

  return (
    <div className='modal'>
      <Modal show={isdeletemodal}
        onHide={closeDeleteModal}
        centered={true}
        animation={false}
        size='sm'
      >
        <Modal.Header className='modal__head'>
          <h3>Are you sure!</h3>
        </Modal.Header>
        <Modal.Body className='modal__body'>
          <span className='modal__body--icon'><i className='fa fa-trash'></i></span>
          You won't be able to revert this!
        </Modal.Body>
        <Modal.Footer className='modal__foot'>
          <input type='button' className='modal__foot--btn' value='Yes Delete It' onClick={deleteDatas} />
          <input type='button' className='modal__foot--btn modal__foot--btn-close' value='Cancel' onClick={closeDeleteModal} />
        </Modal.Footer>
      </Modal>
    </div>
  );



}

export default DeleteModal
